import React from "react";
import { Typography } from "@material-ui/core";
import BlockContent from "@sanity/block-content-to-react";
import sanity from "~/src/api/sanity";
import * as ROUTES from "~/src/constants/routes";
import MONTHS_OF_THE_YEAR from "~/src/constants/months";
import {
  AppWithAuthentication,
  LongformContent,
  Head,
  Link,
  Layout,
  Card,
  Spacing,
  Video,
} from "~/src/components/global";

import {
  Image,
  MailchimpForm,
} from "~/src/components/content";

const query = `*[_type == 'post' && slug.current == $id] {
  _id,
  title,
  slug,
  "mainImage": mainImage.asset->url,
  body[]{..., "asset": asset->},
  publishedAt
}[0]`;

const serializers = {
  types: {
    video: ({ node }) => {
      const { url } = node;
      return <Video source={url} autoplay noAudio />;
    },
    divider: () => <hr />,
  },
};

const BlogPost = (props) => {
  const date = new Date(props.post.publishedAt);
  const dateMarkup = date ? `${date.getDate()} ${MONTHS_OF_THE_YEAR[date.getMonth()].label} ${date.getFullYear()}` : null;

  return (
  <AppWithAuthentication>
    <Layout size="sm">
      <Head
        title={`${props.post.title} · Blog · Bolstr`}
        image={props.post.feature_image}
        description={props.post.excerpt}
      />

      <Link href={ROUTES.BLOG}>
        ← All blog posts
      </Link>
      <Typography variant="h1" gutterBottom>{props.post.title}</Typography>
      <Typography variant="h3" color="textSecondary">{dateMarkup}</Typography>

      <Spacing>
        <LongformContent>
          {props.post.mainImage && (
            <Image src={props.post.mainImage} alt={props.post.title} />
          )}

          <BlockContent blocks={props.post.body} serializers={serializers} />
        </LongformContent>
      </Spacing>

      <Card title="Subscribe to the newsletter">
        <MailchimpForm />
      </Card>
    </Layout>
  </AppWithAuthentication>
  );
};

BlogPost.getInitialProps = async (ctx) => ({
  post: await sanity.fetch(query, { id: ctx.query.id }),
});

export default BlogPost;
